import { Action, Node } from '@lss/common/src/shell/Actions/Action';
import Game from '@lss/common/src/shell/Game';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { PanResponder, PanResponderGestureState, StyleSheet } from 'react-native';
import Character from '../shell/Character';
import { sleep } from '../shell/utils/sleep';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import AdvanceSlice, { selectAdvance, setAdvance, setClickedScreen } from '../store/slices/AdvanceSlice';
import { selectGameObject } from '../store/slices/gameObjectSlice';
import { GameNames } from '../store/slices/GameTypes';
import { selectMenu, setMenu } from '../store/slices/menuSlice';
import { selectSaves } from '../store/slices/savesSlice';
import { actionListenerRef, store } from '../store/store';
import { doRedo, doUndo } from './doUndoRedo';
import { TSound } from './TSound';
import { TWrapper } from './TWrapper';
import { useSkippingLogic } from './useSkippingLogic';


// ms
const ROLLBACK_DEBOUNCE_INTERVAL = 50;

export enum RollbackType {
    present = 0,
    past = 1,
    future = 2
}


interface TAdvanceProps {
    children?: React.ReactNode;
}


const TProgress: React.FC<TAdvanceProps> = ({ children }) => {
    const dispatch = useAppDispatch();
    const advanceState = useAppSelector(selectAdvance);
    const menuSlice = useAppSelector(selectMenu);
    const gameObject = useAppSelector(selectGameObject);
    const queue = useRef<{ queue: Node<Function>[], isRunning: boolean; }>({ queue: [], isRunning: false });
    const actionDelay = useRef<NodeJS.Timeout | undefined>();
    // const rollback = useRef<number>(0);
    let storedMove: PanResponderGestureState;
    let debounceMove: Date;
    const SKIP_DELAY = (menuSlice.settings.skipSpeedValue + 10) || 15;
    const skipOn = [
        GameNames.IMAGE,
        GameNames.ANIMATION,
        GameNames.IMAGE_PAR,
        GameNames.CONDITION,
        GameNames.CHARACTERS,
        GameNames.INSTA,
        GameNames.SET_INSTA,
        GameNames.JUMP,
        GameNames.END_REPLAY,
        GameNames.SOUND,

    ];
    const styles = StyleSheet.create({
        wrapper: {
            // height: "100%"
            position: "absolute",
            height: "100%",
            width: "100%",
            zIndex: -1
        },

    });

    const skipLogic = () => {
        if (gameObject.present.lastUpdated == null || typeof gameObject.present.lastUpdated === 'string' || skipOn.includes(gameObject.present.lastUpdated) || gameObject.present.shouldStop == false) {
            if (gameObject.present.lastUpdated === GameNames.CHARACTERS) {
                // return false;
                // return false;
            }
            if (gameObject.present.shouldStop === true && typeof gameObject.present.lastUpdated !== 'string' && gameObject.present.lastUpdated !== GameNames.CHARACTERS) {
                return false;
            }
            return true;
        }
        return false;
    };
    const doAdvance = async () => {
        clearNextActionDelayed();
        const action = Game.Action;

        if (Game.rollback) {
            skipLogic() ? Game.rollback === RollbackType.past ? doUndo() : doRedo() : null;
            return;
        }

        if (gameObject.present.waitInput) { return; }
        if (!action) {
            Game.Action = Action.head;
            queue.current.queue.push(Game.Action!);
        } else {

            const nextAction = await Action.getNextAction();
            if (nextAction) {

                queue.current.queue.push(nextAction);
            } else {
            }
            if (nextAction?.data?.options?.wait && typeof nextAction?.data?.options?.wait === "number") {
                doNextActionDelayed(nextAction);
            }
        }
        actionQueue();

    };
    function doNextActionDelayed(action: Node<Function> | null | undefined) {
        actionDelay.current = setTimeout(() => {
            doAdvance();
        }, action?.data?.options?.wait * 1000);
    }
    function clearNextActionDelayed() {
        if (actionDelay.current) {
            clearTimeout(actionDelay.current);
        }
    }


    const actionQueue = async () => {
        if (queue.current.isRunning) { return; }
        queue.current.isRunning = true;
        if (menuSlice.loading) { dispatch(setMenu({ loading: false })); }
        while (queue.current.queue.length > 0) {
            queue.current.queue.shift()?.func();
            await sleep(SKIP_DELAY);

        }
        queue.current.isRunning = false;

    };



    useEffect(() => {
        if (actionListenerRef.current === "GAME_OBJECT_CLEAR") {
            console.log("cleared object");
            return;
        }
        if (menuSlice.loading) { return; }
        if (gameObject.present.lastUpdated === GameNames.INIT) { return; }
        if (useSkippingLogic()) {
            doAdvance();
            return;
        }



        if (gameObject.present.shouldStop && !Game.rollback || advanceState.canAdvance) {
            return;
        }
        doAdvance();

    }, [gameObject]);

    const handleRollback = (promise?: any) => {
        if (gameObject.present.waitInput) { return; }
        Action.head = null;
        Action.searchScene({ scene: gameObject.present, promiseData: promise, additionalScenes: gameObject.past?.slice(-10), potentialNode: null });
        Game.rollback = 0;
        return;
    };
    useEffect(() => {

        if (advanceState.canAdvance) {
            if (Game.rollback) {
                return handleRollback(advanceState.promise);
            }
            if (advanceState.promise != null) {
                Game.Action?.promise(advanceState.promise);
            }
            doAdvance();
            dispatch(setAdvance({ canAdvance: false }));
        }

    }, [advanceState]);

    const advance = () => {
        if (advanceState.keyPressed === "KeyH") {
            dispatch(setAdvance({ canAdvance: false, skipping: false, keyPressed: undefined }));
            return;
        }
        dispatch(setClickedScreen());
        if (Game.rollback) {
            return handleRollback();
        }
        Game.rollback = 0;
        doAdvance();
    };

    const onWheel = (e: any) => {
        // e.preventDefault()

        if (e.deltaY > 0) {

            for (let i = 0; i < e.deltaY; i += 100) {
                doRedo();
            }

        } else {
            for (let i = 0; i > e.deltaY; i -= 100) {
                doUndo();
            }
        }
    };


    return (
        <>
            <TSound></TSound>
            <TWrapper
                contentContainerStyle={styles.wrapper}
                // TODO: think of a new way to rollback, this one disturb the clicking on buttons.
                // {...panResponder.panHandlers}
                onScroll={onWheel}
                onTouchStart={() => advance()}

            >
                {children}

            </TWrapper>
        </>


    );

};



export default TProgress;


